module.exports = __webpack_public_path__ + "static/media/m1_sf_14.c3b2ff50.png";